import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const resetCode = async (e) => {
    e.preventDefault();

    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      Email: email,
    });

    let response = await fetch("/send-reset-code", {
      method: "POST",
      body: bodyContent,
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      toast.success(data.message);
      navigate("/reset-password");
    } else {
      toast.error(data.error);
    }
  };
  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
      <Form onSubmit={resetCode} className="border border-2 p-4 rounded-2">
        <Form.Group className="mb-3 row" controlId="email">
          <div className="col-3">
            <Form.Label>Email</Form.Label>
          </div>
          <div className="col-9">
            <Form.Control
              type="email"
              placeholder="Please enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </Form.Group>
        <div className="text-center">
          <div className="my-3">
            <Button type="submit" variant="secondary" className="btn-sm">
              Send me code
            </Button>
            <div className="my-2">
              <Link to={"/login"}>Go to login page</Link>
            </div>
            <div className="my-2">
              <Link to={"/reset-password"}>I already have a code</Link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}
